export default class ArrayValueObject {

    /**
     * ArrayValueObject constructor.
     *
     * @param {Array<any>} values
     */
    constructor(values) {
        this.values = values;
    }

}